<template>
  <div
    :style="{ 
      backgroundImage: 'url(' + bg + ')',
      backgroundPosition: 'center'
    }"
  >

    <profile-header></profile-header>

    <v-container fill-height grid-list-lg>
      <v-layout justify-center>
        <v-flex md10>
          <registration
            :apiUrl="apiUrl"
          ></registration>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
import ProfileHeader from '@/components/profile/profileHeader'
import Registration from '@/components/registration'

export default {
  components: {
    ProfileHeader,
    Registration
  },
  data () {
    return {
      bg: require('@/assets/bg/water_6.png')
    }
  },
  props: {
    apiUrl: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/index.vue